<template>
  <div>
    <div class="data-card__header">
      <h3 class="my-0">Детальная информация</h3>
      <div>
        <el-button size="medium" :loading="updateProgress || deleteProgress" @click="showDeleteDialog=true">Удалить</el-button>
<!--        <template v-if="isEdited">-->
<!--          <el-button type="primary" size="medium" :loading="updateProgress || deleteProgress" @click="onSave">-->
<!--            Сохранить-->
<!--          </el-button>-->
<!--        </template>-->
<!--        <el-button v-else size="medium" @click="isEdited=true">-->
<!--          Изменить-->
<!--        </el-button>-->
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 col-xl-9">
        <div class="card-table">
          <el-form :model="form" :rules="rules" ref="form">
            <table :class="['card-table card-table_border text-secondary', {'is-edited': isEdited}]">
            <tr>
                <td>Название</td>
                <td :class="{'pb-0': isEdited}">
                  <el-form-item v-if="isEdited" prop="name" class="no-mb">
                    <el-input placeholder="Название услуги" v-model="form.name" />
                  </el-form-item>
                  <span v-else>{{item.name}}</span>
                </td>
              </tr>
<!--              <tr>-->
<!--                <td>Артикул</td>-->
<!--                <td :class="{'pb-0': isEdited}">-->
<!--                  <el-form-item v-if="isEdited" prop="vendorCode" class="no-mb">-->
<!--                    <el-input placeholder="Артикул" v-model.trim="form.vendorCode" />-->
<!--                  </el-form-item>-->
<!--                  <span v-else>{{item.vendorCode}}</span>-->
<!--                </td>-->
<!--              </tr>-->
              <tr>
                <td>Описание</td>
                <td :class="{'pb-0': isEdited}">
                  <el-form-item v-if="isEdited" prop="description" class="no-mb">
                    <el-input type="textarea"
                              :rows="4"
                              maxlength="200"
                              show-word-limit
                              placeholder="Описание"
                              v-model="form.description"
                              resize="none"/>
                  </el-form-item>
                  <span v-else>{{item.description}}</span>
                </td>
              </tr>
            </table>
          </el-form>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-9 mt-4">
        <h3 class="my-0">Шаги</h3>
        <div>
          <div v-for="(step, ind) of form.steps" :key="ind">
            <el-form :model="step" :rules="stepRules" ref="stepsForms" class="service-step__wrapper">
              <div class="service-step">
                <div class="service-step__index">Шаг {{ind+1}}</div>

                <div class="service-step__name">
                  <el-form-item v-if="isEdited" prop="name" class="mb-0">
                    <el-input size="medium" placeholder="Название шага" v-model="step.name" />
                  </el-form-item>
                  <span v-else>{{step.name}}</span>
                </div>

                <div class="service-step__select">
                  <el-form-item prop="completeStepActionId" class="mb-0">
                    <el-select size="medium"
                               :disabled="!isEdited"
                               class="w-100"
                               @change="onChangeStepAction(ind, $event)"
                               :value="step.completeStepActionId"
                               placeholder="Действие">
                      <el-option
                        v-for="option in serviceStepActions"
                        :key="option.id"
                        :label="option.title"
                        :value="option.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <div v-if="isEdited" class="service-step__actions">
                  <el-button type="text" @click="deleteStep(ind)" :disabled="form.steps.length===1">
                    <i class="el-icon-delete el-icon-hover pointer"></i>
                  </el-button>
                </div>
              </div>
              <div class="mt-3">
                <el-checkbox label="Обязательный" v-model="step.isMandatory" :disabled="!isEdited"></el-checkbox>
              </div>
            </el-form>
          </div>
          <div v-if="isEdited" class="mt-4">
            <el-button size="medium" icon="el-icon-plus"
                       @click="addStep"
                       :loading="updateProgress || deleteProgress">
              Добавить шаг
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <DeleteDialog v-if="showDeleteDialog" :visible.sync="showDeleteDialog" :progress="deleteProgress" @onDelete="onDelete" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import DeleteDialog from '@/components/dialogs/DeleteDialog';

export default {
  components: {
    DeleteDialog,
  },
  data: () => ({
    showDeleteDialog: false,
    isEdited: false,
    form: {
      name: '',
      vendorCode: '',
      description: '',
      steps: [
        {
          name: '',
          completeStepActionId: null,
          isMandatory: false,
        },
      ],
    },
    isValidForm: true,

    rules: {
      name: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
      vendorCode: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
      description: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
    },
    stepRules: {
      name: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
      completeStepActionId: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
    },
  }),
  created() {
    this.fetchItems();
    this.fillForm();
  },
  computed: {
    ...mapGetters({
      updateProgress: 'services/updateProgress',
      deleteProgress: 'services/deleteProgress',
      item: 'services/item',
      serviceStepActions: 'serviceStepActionsDrop/items',
    }),
  },
  methods: {
    ...mapActions({
      updateItem: 'services/updateItem',
      deleteItem: 'services/deleteItem',
      fetchItems: 'serviceStepActionsDrop/fetchItems',
    }),
    fillForm() {
      if (this.item) {
        this.form.name = this.item.name;
        this.form.vendorCode = this.item.vendorCode;
        this.form.description = this.item.description;
        this.form.steps = this.item.steps.map((s) => ({
          id: s.id,
          name: s.name,
          completeStepActionId: s.completeStepActionId,
          isMandatory: s.isMandatory,
          number: s.number,
          serviceId: s.serviceId,
        }));
      } else {
        this.form.name = '';
        this.form.vendorCode = '';
        this.form.description = '';
        this.form.steps = [
          {
            name: '',
            completeStepActionId: null,
            isMandatory: false,
          },
        ];
      }
    },

    onChangeStepAction(ind, val) {
      this.form.steps[ind].completeStepActionId = val;
    },
    addStep() {
      this.form.steps.push({
        name: '',
        completeStepActionId: null,
        isMandatory: false,
      });
    },
    deleteStep(ind) {
      this.form.steps.splice(ind, 1);
    },
    checkSteps() {
      this.form.steps.forEach((step, index) => {
        step.number = index + 1;
      });
      this.isValidForm = true;
      if (!this.$refs.stepsForms) return;
      this.$refs.stepsForms.forEach((form) => {
        form.validate((valid) => {
          if (!valid) this.isValidForm = false;
        });
      });
    },

    onDelete() {
      this.deleteItem({ id: this.item.id })
        .then(() => {})
        .catch(() => {});
    },
    onSave() {
      this.checkSteps();

      this.$refs.form.validate((valid) => {
        this.isValidForm = this.isValidForm && valid;
      });

      if (!this.isValidForm) return;
      this.updateItem({ id: this.item.id, data: this.form });
    },
  },
  watch: {
    item() {
      this.isEdited = false;
      this.fillForm();
    },
  },
};
</script>
